import "../../main";
import $ from 'jquery';
import { StringExtensions } from 'rustig';
import { AddsCustomToolTip } from "../map/customtooltip"
import { ExtendedBoundsRenderer } from '../map/extendedboundsrenderer'

export class Hospitals {
  private map: google.maps.Map;
  private renderer: ExtendedBoundsRenderer;

  public constructor(map: google.maps.Map, data: Array<IHospital>) {
    this.map = map;
    let hospitals = data.map((x) => this.buildHospital(x));
    this.renderer = new ExtendedBoundsRenderer(this.map, 2, hospitals);

    $(document).on('refresh-hospitals', (event: Event, data?: IHospitalData) => {
      this.refresh(data.Hospitals);
    });
    $(document).on('toggle-hospitals', this.toggle.bind(this));

    let $hospitals = $('[data-hospitals]');
    if ($hospitals.length)
      $(document).trigger('refresh-hospitals', <IHospitalData>JSON.parse($hospitals.val() as string));

    let shouldShowHospitals = StringExtensions.toBoolean($('[data-show-hospitals]').val() as string);
    $(document).trigger('toggle-hospitals', shouldShowHospitals);
  }

  public refresh(data: Array<IHospital>): void {
    let hospitals = data.map((x) => this.buildHospital(x));
    this.renderer.update(hospitals);
  }

  public enable(): void {
    this.renderer.enable();
  }

  public disable(): void {
    this.renderer.disable();
  }

  private buildHospital(data: IHospital): google.maps.marker.AdvancedMarkerElement {
    let pin = new Image();
    pin.src = '/Content/v3/Images/maps/pins/hospital.png';

    let marker = new google.maps.marker.AdvancedMarkerElement({
      position: new google.maps.LatLng(data.Latitude, data.Longitude),
      content: pin,
    });
    new AddsCustomToolTip().execute(marker, `<div class="tooltip-content">${data.Name}</div>`);

    google.maps.event.addListener(marker, 'click', function () {
      let infoWindow = new google.maps.InfoWindow();
      infoWindow.setContent(`<h2 class="text-title">${data.Name}</h2><span>${data.Address}</span>`);
      infoWindow.open(marker.map, marker);
    });

    return marker;
  }

  private toggle(event: Event, shouldShowHospitals: boolean): void {
    if (shouldShowHospitals)
      this.enable();
    else
      this.disable();
  }
}

export interface IHospitalData {
  Hospitals: Array<IHospital>;
}

export interface IHospital {
  Name: string;
  Address: string;
  Latitude: number;
  Longitude: number;
}
